import React from 'react';
import I18n from 'i18n-js';
import classNames from 'classnames';
import { MParticleEventName } from '../elog/mparticle_types';
import { trackEvent } from '../elog/mparticle_tracker';

interface IProps {
  remMaxHeight?: number;
  children?: React.ReactNode;
  trackingName?: string;
}

export function TruncationContainer({ children, remMaxHeight, trackingName }: IProps) {
  const [isOpen, setIsOpen] = React.useState(false);
  const elementRef = React.useRef<HTMLDivElement>();
  const pixelHeight = remMaxHeight ? remMaxHeight * 10 : null;
  const clientHeight = elementRef.current?.clientHeight;
  const shouldTruncate = !isOpen && remMaxHeight;
  const classes = classNames(
    'truncation-container',
    { 'truncation-container--open': !shouldTruncate },
  );

  const clickEvent = {
    componentName: trackingName || 'TruncationContainer',
    eventName: MParticleEventName.ClickedComponent,
  };

  const onClick = () => {
    trackEvent(clickEvent);
    setIsOpen(true);
  };

  React.useEffect(() => {
    if (clientHeight < pixelHeight) {
      setIsOpen(true);
    }
  }, [clientHeight, pixelHeight]);

  const style = shouldTruncate ? { maxHeight: `${remMaxHeight}rem` } : {};

  return (
    <div className={classes} style={style} ref={elementRef}>
      {children}
      <div className="truncation-container__show-more">
        <button
          className="truncation-container__show-more__button"
          onClick={onClick}
          type="button"
        >
          {I18n.t('commons.truncationContainer.showMore')}
        </button>
      </div>
    </div>
  );
}
